import { Cloudinary } from "cloudinary-core";

const cl = new Cloudinary({ cloud_name: "dxqlofzxq"});

export default cl;